import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <main data-reveal className="py-24 text-center">
      <p className="text-[10px] tracking-[0.2em] text-rose uppercase">404</p>
      <h1 className="mt-4 font-serif text-5xl font-medium">this page left the party.</h1>
      <Link to="/" className="mt-8 inline-block border-b border-ink pb-1 text-[11px] tracking-[0.2em] uppercase hover:border-rose hover:text-rose">
        Back to TIGG
      </Link>
    </main>
  )
}
